module.exports = __webpack_public_path__ + "img/c762ca6.png";